<template>
    <v-container id="DetalleReporte" class="pt-5">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos Generales </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-file-document</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Número de averiguación Previa: "
                                    :subtitle="this.detalleReporteData.svnumave"></vs-list-item>
                                <vs-list-item title="Número de Póliza:"
                                    :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Número de Siniestro:"
                                    :subtitle="this.detalleReporteData.svnumsin"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Estado:" :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Aseguradora:"
                                    :subtitle="this.detalleReporteData.clnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Flotilla:"
                                    :subtitle="this.detalleReporteData.flnomcorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Asegurado:"
                                    :subtitle="this.detalleReporteData.asnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Conductor:"
                                    :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                            </vs-list>

                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Otros Datos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-account-supervisor</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Abogado:"
                                    :subtitle="this.detalleReporteData.prnombrecorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Ajustador:"
                                    :subtitle="this.detalleReporteData.svajustador"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Supervisor:"
                                    :subtitle="this.detalleReporteData.sunombrecorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Gerente:"
                                    :subtitle="this.detalleReporteData.geresponsablecorto"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-calendar</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del siniestro:"
                                    :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del reporte:"
                                    :subtitle="this.detalleReporteData.svfhreporteaux"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora de conclusión:"
                                    :subtitle="this.detalleReporteData.svfhconclusion"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>

                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-information-outline</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos del Vehiculo </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-car-info</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Serie: " :subtitle="this.detalleReporteData.svserie"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Marca: " :subtitle="this.detalleReporteData.svmarca"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Modelo: " :subtitle="this.detalleReporteData.svmodelo"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Año: " :subtitle="this.detalleReporteData.svanio"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Color: " :subtitle="this.detalleReporteData.svcolor"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Placas: " :subtitle="this.detalleReporteData.svplaca"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Número económico: "
                                    :subtitle="this.detalleReporteData.danumeco"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Centro de distribución: "
                                    :subtitle="this.detalleReporteData.dacedis"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <Telefonos></Telefonos>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Lugar de los Hechos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-map-marker-radius</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.svlughec"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Siniestros</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-alert-octagon</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :title="this.detalleReporteData.tsnombre"
                                    :subtitle="this.detalleReporteData.trdesc"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Reporte from '@/services/asistenciaRLV/AsistenciaRLV.service.js';
import Telefonos from '@/components/pages/telefonos/Telefonos.vue'

export default {
    components: {
        Telefonos
    },
    data: function () {
        return {
            showcargando: true,
            detalleReporteData: [],
            telefonos: [],
            svrobo: '',
        };
    },

    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    async mounted() {
        this.showcargando = true
        this.DatosDetalle();
    },
    methods: {
        DatosDetalle() {
            Reporte.DatosDetalle(this).then(data => {
                let auxDetalleReporte = data[0];
                for (const [key, value] of Object.entries(auxDetalleReporte)) {
                    if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
                }

                this.detalleReporteData = auxDetalleReporte;
                this.svrobo = this.detalleReporteData.svrobo.toLowerCase() === 'true'
                this.showcargando = false;
            })
            setTimeout(() => {
            }, "500");
        }
    },



};
</script>

<style scoped>
.v-card__text {
    align-content: center;
    padding-top: 10px !important;
}

#menu_reporte .v-toolbar__content {
    height: 0px !important;
}

#menu_reporte {
    height: 50% !important;
}

#custom-tab-items {
    background-color: transparent !important;
}

#DatosGenerales .v-toolbar__title {
    font-size: 24px;
}

#DatosGenerales .v-list-item__title {
    font-size: 18px;
    /*font-weight: bold;*/
}

#DatosGenerales span.font-weight-bold {
    font-size: 18px;
}

.container {
    max-width: 2536px !important;
}

.vs-list--title {
    font-size: 20px;
}

.vs-list--subtitle {
    font-size: 16px;
}

.mdi-file-document,
.mdi-car-info,
.mdi-card-account-phone,
.mdi-alert-octagon,
.mdi-doctor,
.mdi-folder-alert,
.mdi-badge-account-alert,
.mdi-text-box-multiple-outline,
.mdi-bank,
.mdi-school,
.mdi-archive,
.mdi-school-outline,
.mdi-badge-account-alert-outline,
.mdi-information-outline,
.mdi-map-marker-radius,
.mdi-account-supervisor,
.mdi-calendar,
.mdi-car {
    color: white !important;
}

/* Por debajo de 400px */
/* @media screen and (max-width: 600px){
        #DatosGenerales .v-list-item__title{
        font-size:10px;
        }
    }
    @media only screen and (min-width: 600px) and (max-width: 960px) {
        #DatosGenerales .v-list-item__title{
        font-size:12px;
        }
    }
    @media only screen and (min-width: 960px) and (max-width: 1264px) {
        #DatosGenerales .v-list-item__title{
        font-size:14px;
        }
    }
    @media only screen and (min-width: 1264px) and (max-width: 1904px) {
        #DatosGenerales .v-list-item__title{
        font-size:16px;
        }
    }
    @media only screen and (min-width: 1904px) {
        #DatosGenerales .v-list-item__title{
        font-size:18px;
        }
    } */
#DetalleReporte .vs-list--subtitle {
    font-size: 20px;
    font-weight: 700;
}

#DetalleReporte .vs-list--title {
    font-size: 12.8px;
    font-weight: 700;
}

#titulocard {
    color: white;
}</style>